module.exports = __webpack_public_path__ + "static/media/intuos.42815b5a.svg";